import { by } from 'protractor';
import { Component, OnInit,HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as bath from '../../../../node_modules/thai-baht-text';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-print-invoice-multi-file',
  templateUrl: './print-invoice-multi-file.component.html',
  styleUrls: ['./print-invoice-multi-file.component.scss']
})
export class PrintInvoiceMultiFileComponent implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  datetime = '';
  endtime = '';
  background = '#ffffff'
  isLoading = true;
  all_invoice = [];
  all_user = [];
  type = '';
  day = '';
  month = '';
  year = '';
  base64_img_muni = null;
  img_src = null;
  muni_thname = null;
  muni_amphurth = null;
  muni_tambonth = null;
  muni_thprovince = null;
  muni_postcode = null;
  muni_contact_phone = null;
  qr_code = null;
  municipality = null
  lineqr_code = null;
  base64_img_muni_lineqr = null;
  status_pay = null;
  date_filter = null;
  user = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) { };

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const get_Storage_invoice_multi = sessionStorage.getItem('municipality')
      this.user = JSON.parse(sessionStorage.getItem('user'))
      this.municipality = JSON.parse(get_Storage_invoice_multi)
      this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
      this.qr_code = `http://203.150.210.93:5002/${JSON.parse(get_Storage_invoice_multi).qr_code}`
      this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
      const thname_muni = JSON.parse(get_Storage_invoice_multi).th_name;
      this.muni_thname = this.sanitizer.bypassSecurityTrustHtml(thname_muni);
      const thamphurth_muni = JSON.parse(get_Storage_invoice_multi).th_amphur;
      this.muni_amphurth = this.sanitizer.bypassSecurityTrustHtml(thamphurth_muni);
      const tambonth_muni = JSON.parse(get_Storage_invoice_multi).th_tambon;
      this.muni_tambonth = this.sanitizer.bypassSecurityTrustHtml(tambonth_muni);
      const provinceth_muni = JSON.parse(get_Storage_invoice_multi).th_province;
      this.muni_thprovince = this.sanitizer.bypassSecurityTrustHtml(provinceth_muni);
      const postcode_muni = JSON.parse(get_Storage_invoice_multi).postcode;
      this.muni_postcode = this.sanitizer.bypassSecurityTrustHtml(postcode_muni);
      const phone_muni = JSON.parse(get_Storage_invoice_multi).contact_phone;
      this.muni_contact_phone = this.sanitizer.bypassSecurityTrustHtml(phone_muni);
      this.base64_img_muni_lineqr = `http://203.150.210.93:5002/${JSON.parse(get_Storage_invoice_multi).line_qr_code}`
      this.lineqr_code = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni_lineqr);
      this.date_filter = params['date_filter'];

      this.type = params['report'];
      this.status_pay = params['status_pay']

      switch (this.type) {
        case '1':
          var x = moment.unix(params['datetime']).locale('th-TH');
          var xy = 0;
          xy = parseInt(x.format('YYYY'));

          if (xy > 2500) {
            xy = xy - 543;
          }

          this.year = xy.toString();
          this.month = x.format('MM')
          this.day = x.format('DD')
          this.refresh();
          break;
        case '2':
          this.year = params['year'];
          this.month = params['month'];
          this.day = '01'
          this.refresh();
          break;
        case '3':
          this.year = params['year'];
          this.month = '01';
          this.day = '01'
          this.refresh();
          break;
        case '4':
          this.year = params['year'];
          this.month = params['month'];
          this.day = '01'
          this.refresh();
          break;
        case '5':
          this.year = params['year'];
          this.month = params['month'];
          this.day = '01'
          this.refresh();
          break;
        case '99':
          this.year = '';
          this.month = '';
          this.day = ''
          this.refresh();
          break;
        case '98':
          this.year = '';
          this.month = '';
          this.day = ''
          this.refresh();
          break;
        case '97':
          this.year = '';
          this.month = '';
          this.day = ''
          this.refresh();
          break;
      }


    });
  }

  refresh() {
    this.isLoading = true;
    this.service.postData({
      report_type: this.type,
      day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
      month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
      year: this.year,
      type: this.type,
      status_pay: this.status_pay,
      date_filter: JSON.parse(this.date_filter)
    }, "reports-new/get_reports_all_invoice").then((result: any) => {
      console.log(result);
      this.all_invoice = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
      var xy = 0;
      var users = []

      this.service.postData({ user_id: undefined }, "user-location/get-user-detail").then((result2: any) => {
        this.isLoading = false;
        this.all_user = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        //debugger;
        for (var i = 0; i <= this.all_invoice.length - 1; i++) {
          switch (moment(this.all_invoice[i].create_datetime).format("MM")) {
            case '01':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (มกราคม)';
              break
            case '02':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (กุมภาพันธ์)';
              break
            case '03':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (มีนาคม)';
              break
            case '04':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (เมษายน)';
              break
            case '05':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (พฤษภาคม)';
              break
            case '06':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (มิถุนายน)';
              break
            case '07':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (กรกฏาคม)';
              break
            case '08':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (สิงหาคม)';
              break
            case '09':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (กันยายน)';
              break
            case '10':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (ตุลาคม)';
              break
            case '11':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (พฤศจิกายน)';
              break
            case '12':
              this.all_invoice[i].fee_description = this.all_invoice[i].fee_description + ' (ธันวาคม)';
              break
          }

          this.all_invoice[i].fee_count = this.all_invoice[i].fee_type_price + ' ' + this.all_invoice[i].fee_type_unit;
          this.all_invoice[i].due_datetime = moment(this.all_invoice[i].due_date).format("DD/MM/YYYY");

          xy = 0;
          xy = parseInt(moment(this.all_invoice[i].create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          this.all_invoice[i].create_datetime = moment(this.all_invoice[i].create_datetime).format("DD/MM/") + xy;
          this.all_invoice[i].total_price = this.all_invoice[i].total_price.toFixed(2);
          this.all_invoice[i].total_price_bath = bath(this.all_invoice[i].total_price);

          users = this.all_user.filter((item) => item.user_id == this.all_invoice[i].user_id);
          //debugger;
          if (users.length > 0) {
            this.all_invoice[i].user_id = users[0].user_name;
          }
        }

        setTimeout(() => {
          window.print();
        }, 500);
      })


    })
  }

}

